import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { BaseHierarchicalCrudComponent, GenericForm, ICrudService, ZnHierarchicalViewComponent } from '@zendra/shared';
import {
  GetStandPerRegistersInputDto,
  StandPerRegisterCreateDto,
  StandPerRegisterDto,
  StandPerRegisterExcelDownloadDto,
  StandPerRegisterUpdateDto,
} from 'projects/cbd-proxies/src/lib/planning/dtos/stand-per-register';
import { StandPerRegisterService } from 'projects/cbd-proxies/src/lib/planning/controllers/stand-per-register.service';
import { STANDPERREGISTER_CONFIG, STANDPERREGISTER_FIELDS } from './stand-per-register.config';

@Component({
  selector: 'app-stand-per-register',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, StandPerRegisterService, ConfirmationService],
  templateUrl: './stand-per-register.html',
})
export class StandPerRegister extends BaseHierarchicalCrudComponent<
  StandPerRegisterDto,
  StandPerRegisterCreateDto,
  StandPerRegisterUpdateDto,
  StandPerRegisterExcelDownloadDto
> {
  geographicService = inject(StandPerRegisterService);
  service: ICrudService<StandPerRegisterDto, StandPerRegisterCreateDto, StandPerRegisterUpdateDto, StandPerRegisterExcelDownloadDto> = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    getList: (query: GetStandPerRegistersInputDto) => this.geographicService.getList(query),
    getDownloadToken: () => this.geographicService.getDownloadToken(),
    getListAsExcelFile: input => this.geographicService.getListAsExcelFile(input)
  };
  config = STANDPERREGISTER_CONFIG;
  fields = STANDPERREGISTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandPerRegisterDto): StandPerRegisterUpdateDto {
    return {
      standId: data.standId,
      registerId: data.registerId,
      standRegisterArea: data.standRegisterArea,
      standAreaPercentage: data.standAreaPercentage,
      registerAreaPercentage: data.registerAreaPercentage,
      isMainRegister: data.isMainRegister,
      isLastRegister: data.isLastRegister,
      isStandPerRegisterAvailableInGis: data.isStandPerRegisterAvailableInGis,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandPerRegister';
  }
}
